module.exports = __webpack_public_path__ + "static/regular-house-6f986c3cf748ffadc22b9d1235c49a2b.png";